/**
 * Fix overflow:hidden hashed anchor link
 * scrolls
 *
 * @since 1.0.0
 * @package uma
 */

( function($) {

	// stuff we need
	var htmlBody   = $( 'html, body' );
	var headerOffset = $( 'header[role="banner"]' ).outerHeight();

	/**
	 * Grab hash links and filter out the ones
	 * that don't link to anything or are for
	 * interactive JS elements
	 */
	var hashAnchors = $( 'a[href*="#"]' )
		.not( '[href="#"]' )
		.not( '[href="#0"]' )
		.not( '[href*="#feature-"]' )
		.not( '[href*="#tab"]')
		.not( '[href*="#home-slide-"]' )
		.not( '[href*="#dealer"]' )
		.not( '[href*="#general"]' );

	var hashExcludes = [
		'#',
		'#feature-',
		'#tab',
		'#home-slide-',
		'#dealer',
		'#general'
	];

	// on ready
	$( document ).ready( function() {

		// bind them
		hashAnchors.click( doHashScroll );

		/**
		 * On-page scroll to hash
		 *
		 * @since 1.0.0
		 */
		function doHashScroll( event ) {

			// if NOT on-page link
			if (
				location.pathname.replace(/^\//, '') !== this.pathname.replace(/^\//, '') ||
				location.hostname !== this.hostname
			) {
				return;
			}


			// don't do the normal "jump"
			event.preventDefault();
			// figure out element to scroll to
			targetHash = this.hash.replace(/^\//, '');
			var target = $( targetHash );
			target = target.length ? target : $( '[name=' + this.hash.slice(1) + ']' );

			// does a scroll target exist?
			if ( target.length ) {

				// console.log(target + ' exists');
				htmlBody.animate({
					scrollTop : target.offset().top - headerOffset
				}, 1000, function() {

					// callback after animation
					// must change focus!
					var $target = $( target );
					$target.focus();

					// check if target was focused
					if ( $target.is( ":focus" ) ) {
						return false;
					}

					// add tabindex for elements not focusable, then focus
					else {
						$target.attr( 'tabindex', '-1' ); 
						$target.focus();
					}
				});
			}
		} // doHashScroll()

	}); // document.ready

	/**
	 * Scroll [main] overflow to top
	 */
	function scrollMainToTop() {
		$( '[role="main"]' ).scrollTop( 0 );
		window.scrollTo( 0, 0 );
	}

	/**
	 * Scroll to top
	 */
	function scrollToTop() {
		scroll( 0, 0 );
	}



	/**
	 * On page load, cancel out the default
	 * "scroll jump" and fix [main] overflow
	 */
	if ( window.location.hash && jQuery.inArray( window.location.hash, hashExcludes ) == -1 && window.location.hash.indexOf('#home-slide-') == -1   ) {

		// check if carousel exist. If so, wait for it to load
		if( $('.banner-carousel').length ) {
			// console.log('Theres a banner');
			var $owl = $( '.owl-carousel.banner-carousel' );
			$owl.on('initialized.owl.carousel', function(event){ 
				// console.log('it loaded');
				// scrollAnimate();
			});

		} else {
			// console.log('it aint');
			// scrollAnimate();
		}

	}

	function scrollAnimate() {
		// undo overflow: hidden scroll
		scrollMainToTop();
		setTimeout( scrollMainToTop, 10 );

		// go to top right away; add fallback for
		// some browsers
		scrollToTop();
		setTimeout( scrollToTop, 1 );
		// console.log('I should scroll to: ' + $( window.location.hash ).scrollTop());
		var temp = $( window.location.hash ).offset();

		// scroll to hash
		htmlBody.animate({
			scrollTop : $( window.location.hash ).offset().top - headerOffset
		}, 800);
	}

})( jQuery );